@if (jobs().length > 0) {
  <button
    type="button"
    class="indicator-btn"
    [ngbTooltip]="jobsTooltip"
    container="body"
    placement="top-end"
    tooltipClass="bg-jobs-tooltip"
  >
    <i class="bi bi-arrow-repeat spinning"></i>
    @if (jobs().length > 1) {
      <span class="badge bg-danger badge-count">{{ jobs().length }}</span>
    }
  </button>

  <ng-template #jobsTooltip>
    @for (job of jobs(); track job.id) {
      <div class="job-row">{{ job.description }}</div>
    }
  </ng-template>
}
